import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/userSlice";
import { Icon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { count } from "firebase/firestore";

 const API_BASE = "https://posible-crm-engine-1066595118037.asia-south1.run.app/api/customer-intelligence";
//const API_BASE = "http://localhost:3000/api/customer-intelligence";

const ArrowUpIcon = ({ className = "w-4 h-4" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
  </svg>
);

const ArrowDownIcon = ({ className = "w-4 h-4" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);
// const SummaryCard = ({ title, value, subtitle, bg, status }) => {
//   const percent = Number(subtitle ?? 0);
//   const isPositive = percent > 0;
//   const isNegative = percent < 0;

//   return (
//     <div className="bg-white rounded-lg p-5 border border-gray-200 hover:shadow-md transition-shadow">
//       <div className="flex items-center justify-between mb-3">
//         <span className="text-sm text-gray-600 font-medium">{title}</span>
//         {status && (
//           <span
//             className={`text-xs px-2 py-0.5 rounded border ${status.color}`}
//           >
//             {status.text}
//           </span>
//         )}
//       </div>

//       <div className="text-3xl font-bold text-gray-900 mb-2">{value ?? 0}</div>

//       {subtitle !== undefined && (
//         <div
//           className={`flex items-center text-sm font-medium ${
//             isPositive
//               ? "text-green-600"
//               : isNegative
//                 ? "text-red-600"
//                 : "text-gray-500"
//           }`}
//         >
//           {isPositive && <ArrowUpIcon className="w-4 h-4 mr-1" />}
//           {isNegative && <ArrowDownIcon className="w-4 h-4 mr-1" />}
//           {Math.abs(percent)}%
//           <span className="ml-2 text-xs text-gray-500">vs 30 days ago</span>
//         </div>
//       )}
//     </div>
//   );
// };
const CustomerCaptureCard = ({ data }) => {
  if (!data) return null;
  console.log("data", data);
  const {
    overall_rate = 0,
    anonymous_bills = 0,
    health_status = "Poor",
    trend_status = "stable",
    recent_rate = 0,
    trend_diff = 0,
  } = data;

  const isPoor = health_status === "Poor";
  const isFair = health_status === "Fair";
  const isGood = health_status === "Good";

  const badgeColor = isGood
    ? "bg-green-100 text-green-700 border-green-200"
    : isFair
      ? "bg-yellow-100 text-yellow-700 border-yellow-200"
      : "bg-red-100 text-red-700 border-red-200";

  const progressColor = isGood
    ? "bg-green-500"
    : isFair
      ? "bg-yellow-500"
      : "bg-red-500";

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <p className="text-xs font-medium text-gray-500">
            Customer Capture Rate
          </p>

          <div className="flex items-center gap-2 mt-1">
            <span className="text-2xl font-bold text-gray-900">
              {Number(overall_rate).toFixed(0)}%
            </span>

            <span
              className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${badgeColor}`}
            >
              {health_status}
            </span>
          </div>
        </div>
      </div>

      {/* Progress */}
      <div className="mt-3">
        <div className="w-full bg-gray-100 rounded-full h-1.5">
          <div
            className={`${progressColor} h-1.5 rounded-full transition-all duration-700`}
            style={{ width: `${overall_rate}%` }}
          />
        </div>

        <p className="text-xs text-gray-500 mt-2">
          <strong className="text-gray-900">
            {anonymous_bills.toLocaleString()}
          </strong>{" "}
          bills were anonymous
        </p>

        {isPoor && (
          <p className="text-[11px] text-red-600 font-medium mt-1">
            Cannot re-target {100 - overall_rate}% of sales
          </p>
        )}
      </div>

      {/* 🔥 NEW: Last 30 Days Trend Section */}
      <div className="mt-1 pt-0 border-t border-gray-100">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs font-bold text-gray-500">
            Last 30 Days Trend
          </span>

          {trend_status === "improving" && (
            <span className="text-xs font-bold text-green-700 bg-green-50 px-2 py-0.5 rounded flex items-center gap-1">
              ↗️ {recent_rate}% (Up)
            </span>
          )}

          {trend_status === "declining" && (
            <span className="text-xs font-bold text-red-700 bg-red-50 px-2 py-0.5 rounded flex items-center gap-1">
              ↘️ {recent_rate}% (Down)
            </span>
          )}

          {trend_status === "stable" && (
            <span className="text-xs font-bold text-gray-600 bg-gray-100 px-2 py-0.5 rounded flex items-center gap-1">
              ➡ {recent_rate}% (Stable)
            </span>
          )}
        </div>

        <p className="text-[11px] text-gray-500 mt-1">
          {trend_status === "stable" && (
            <>
              Staff performance is <strong>consistent</strong>. Matching your
              yearly average.
            </>
          )}

          {trend_status === "improving" && (
            <>
              Staff is improving! Recent capture is{" "}
              <strong className="text-green-600">+{trend_diff}%</strong> higher
              than average.
            </>
          )}

          {trend_status === "declining" && (
            <>
              Action needed. Recent capture dropped{" "}
              <strong className="text-red-600">{Math.abs(trend_diff)}%</strong>{" "}
              below average.
            </>
          )}
        </p>
      </div>
    </div>
  );
};
const WalletLiabilityCard = ({ total = 0, customerCount = 0 }) => {
  return (
    <div className="col-span-1 md:col-span-1 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-6 text-white shadow-lg flex flex-col justify-between">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider">
            Total Wallet Liability
          </p>

          <h3 className="text-2xl font-bold mt-1">
            ₹{Number(total).toLocaleString("en-IN")}
          </h3>
        </div>

        <div className="h-10 w-10 rounded-full bg-gray-700 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-yellow-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
            />
          </svg>
        </div>
      </div>

      <p className="text-xs text-gray-400 mt-2">
        Prepaid cash held by{" "}
        <strong className="text-white">
          {customerCount?.toLocaleString("en-IN")}
        </strong>{" "}
        customers.
      </p>
    </div>
  );
};
const SummaryCard = ({
  title,
  value = 0,
  subtitle,
  changeLabel,
  badge,
  theme = "light",
  borderColor = "border-gray-200",
  accentColor = "bg-gray-400",
  totalCustomers = 0,
}) => {
  const percent = Number(subtitle ?? 0);
  const isPositive = percent > 0;
  const isNegative = percent < 0;
  const isPrimary = theme === "primary";

  // ✅ Segment Share Calculation (Correct Logic)
  const segmentShare = totalCustomers > 0 ? (value / totalCustomers) * 100 : 0;

  return (
    <div
      className={`rounded-xl p-5 transition-all duration-300 ${
        isPrimary
          ? "bg-indigo-700 text-white shadow-lg"
          : `bg-white border ${borderColor} hover:shadow-md`
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <span
          className={`text-sm font-medium ${
            isPrimary ? "text-indigo-100" : "text-gray-600"
          }`}
        >
          {title}
        </span>

        {badge && (
          <span
            className={`text-xs px-2 py-1 rounded-full font-medium ${
              isPrimary ? "bg-indigo-500 text-white" : badge.color
            }`}
          >
            {badge.text}
          </span>
        )}
      </div>

      {/* Main Value */}
      <div
        className={`text-3xl font-bold mb-3 ${
          isPrimary ? "text-white" : "text-gray-900"
        }`}
      >
        {value}
      </div>

      {/* Growth Text */}
      {subtitle !== undefined && (
        <div
          className={`flex items-center text-sm font-medium mb-3 ${
            isPositive
              ? "text-green-600"
              : isNegative
                ? "text-red-600"
                : "text-gray-500"
          }`}
        >
          {isPositive && <ArrowUpIcon className="w-4 h-4 mr-1" />}
          {isNegative && <ArrowDownIcon className="w-4 h-4 mr-1" />}
          {changeLabel && changeLabel !== "" && `${Math.abs(percent)}%`}
          <span className="ml-2 text-xs text-gray-500">{changeLabel}</span>
        </div>
      )}

      {/* Segment Share Bar (NOT growth %) */}
      {!isPrimary && (
        <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-1.5 rounded-full transition-all duration-700 ${accentColor}`}
            style={{
              width: `${Math.min(segmentShare, 100)}%`,
            }}
          />
        </div>
      )}
    </div>
  );
};
const SegmentRow = ({
  name,
  avgAOV,
  avgRecency,
  health,
  frequencyLabel,
  avgFrequencyRaw,
  customerCount,
  membershipGap,
  loyaltyGap,
  onClick,
  onClickMembership,
  onClickLoyalty,
}) => {
  const showLoyaltyGapsForSegment = [
    "Champions",
    "Loyal Customers",
    "Potential Loyalist",
    "New Promising",
  ];
  const getHealthColor = (health) => {
    if (health >= 75) return "bg-green-500";
    if (health >= 50) return "bg-yellow-400";
    return "bg-red-500";
  };

  const getDotColor = (name) => {
    if (name === "Champions") return "bg-green-500";
    if (name === "Loyal Customers") return "bg-blue-500";
    if (name === "At Risk") return "bg-red-500 animate-pulse"; // 👈 blink
    if (name === "Potential Loyalist") return "bg-purple-500";
    if (name === "New Promising") return "bg-yellow-500";
    return "bg-gray-400";
  };

  const getLabel = (name) => {
    if (name === "Champions") return "Top 20% Spenders";
    if (name === "Loyal Customers") return "Frequent Buyers";
    if (name === "At Risk") return "Needs Attention";
    if (name === "Potential Loyalist") return "Growth Opportunity";
    if (name === "New Promising") return "Fresh First-Timers";
    return "";
  };

  const getActionButton = (name) => {
    if (name === "Champions")
      return {
        text: "Pitch Membership",
        className: "bg-indigo-600 hover:bg-indigo-700 text-white",
      };

    if (name === "New Promising")
      return {
        text: "Welcome Offer",
        className:
          "bg-cyan-50 text-cyan-700 border border-cyan-300 hover:bg-cyan-100",
      };

    if (name === "At Risk")
      return {
        text: "High Discount Win-Back",
        className: "bg-red-600 hover:bg-red-700 text-white",
      };

    return {
      text: "Action",
      className: "bg-gray-200 text-gray-600 cursor-not-allowed",
    };
  };
  //  const getActionButton = (name) => {
  //     if (name === "Champions") return null;
  //     if (name === "Loyal Customers") return { text: "Reward", color: "bg-blue-600 hover:bg-blue-700" };
  //     if (name === "At Risk") return { text: "↻ Win Back", color: "bg-red-600 hover:bg-red-700" };
  //     if (name === "Potential Loyalist") return { text: "Nurture", color: "bg-purple-600 hover:bg-purple-700" };
  //     return { text: "Ignore", color: "bg-gray-400 cursor-not-allowed" };
  //   };
  const actionBtn = getActionButton(name);
  const noBuyingCyclesForSegments = ["New Promising"];
  return (
    <div className="grid grid-cols-7 gap-6 items-center py-4 px-4 border-b border-gray-100 hover:bg-gray-50 transition-colors">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <div
            className={`w-2.5 h-2.5 rounded-full ${getDotColor(name)}`}
          ></div>
          <span className="font-semibold text-gray-800">{name}</span>
        </div>
        <div
          className={`text-xs ml-4 ${
            name === "At Risk" ? "text-red-600 font-medium" : "text-gray-500"
          }`}
        >
          {getLabel(name)}
        </div>
        <span onClick={onClick} className="text-xs text-blue-500 ml-4">
          view
        </span>
      </div>
      <div className="font-semibold text-gray-900">{customerCount ?? 0}</div>
      <div>
        <div className="font-semibold text-gray-900">₹{avgAOV}</div>
        {/* <div className="text-xs text-green-600 font-medium">High Value</div> */}
      </div>
      {/* <div className="text-gray-900">{avgFrequency}</div> */}
      {!noBuyingCyclesForSegments.includes(name) ? (
        <div>
          <div className="font-medium text-gray-900 flex items-center gap-1.5">
            <svg
              className="w-4 h-4 text-indigo-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>

            {frequencyLabel}
          </div>

          <div className="text-xs text-gray-500 mt-0.5 ml-5">
            {Math.round(avgFrequencyRaw)} visits/yr
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <div
        className={
          avgRecency > 100 ? "text-red-600 font-semibold" : "text-green-600"
        }
      >
        {avgRecency} days ago
      </div>
      {/* Loyalty Gaps Column */}
      <div className="flex flex-col gap-3 min-w-[210px]">
        {/* Membership Gap */}
        {/* {membershipGap?.count>0 && showLoyaltyGapsForSegment.includes(name) && (
    <div onClick={onClickMembership} className="flex items-center">
      
    
      <span className="text-sm text-gray-600 w-28">
        No Membership:
      </span>

     
    <div
  className={`flex flex-col items-center justify-center
  rounded-xl px-4 py-3 w-20
  ${
    name === "At Risk"
      ? "bg-red-100 text-red-700 border border-red-200"
      : "bg-gray-100 text-gray-900"
  }`}
>
  <span className="text-lg font-bold leading-none">
    {membershipGap.count}
  </span>

  <span className="text-xs text-gray-500 leading-none mt-3">
    ({membershipGap.percent}%)
  </span>
</div>
    </div>
  )} */}

        {/* Loyalty Gap */}
        {loyaltyGap && showLoyaltyGapsForSegment.includes(name) && (
          <div onClick={onClickLoyalty} className="flex items-center justif">
            {/* Label */}
            {/* <span className="text-sm text-gray-600 w-28">
       Empty Wallet:
      </span> */}

            {/* Value Box */}
            <div
              className={`flex flex-col items-center justify-center
  rounded-xl px-4 py-3 
  ${
    loyaltyGap?.percent <= 33
      ? "bg-grey-100 text-black-700 border border-grey-200"
      : loyaltyGap?.percent <= 66
        ? "bg-orange-100 text-black-700 border border-orange-200"
        : "bg-red-100 text-black-700 border border-red-200"
  }`}
            >
              <span className="text-lg  font-bold leading-none">
                {loyaltyGap.count} have Empty Wallet
              </span>

              {/* <span className="text-xs text-gray-500 leading-none mt-3">
          ({loyaltyGap.percent}%)
        </span> */}
            </div>
          </div>
        )}
      </div>
      {/* Actions */}
      {/* <div className="flex justify-center">
        <button
          className={`text-sm font-medium px-5 py-2 rounded-lg transition-colors ${actionBtn.className}`}
          onClick={(e) => {
            e.stopPropagation(); // prevent row click
          }}
        >
          {actionBtn.text}
        </button>
      </div> */}
      {/* <div>
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div
            className={`h-2 ${getHealthColor(health)} transition-all duration-500`}
            style={{ width: `${health}%` }}
          />
        </div>
      </div> */}
      {/* <div className="flex items-center gap-2">
        <button className="text-xs text-gray-600 hover:text-gray-900 font-medium px-3 py-1 hover:bg-gray-100 rounded transition-colors">
          VIEW
        </button>
        <button
          className={`text-xs text-white font-medium px-3 py-1 rounded transition-colors ${actionBtn.color}`}
        >
          {actionBtn.text}
        </button>
      </div> */}
    </div>
  );
};

const CustomersDashboard = () => {
  const [summary, setSummary] = useState(null);
  const [segments, setSegments] = useState([]);
  const [walletDetails, setWalletDetails] = useState([]);
  const [loyaltyGaps, setLoyaltyGaps] = useState([]);
  const [membershipGaps, setMembershipGaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useSelector(selectUser);

  const navigate = useNavigate();

  console.log("user", user);
  const registrationId = user.RegistrationID;
  const segmentOrder = [
    "Champions",
    "Loyal Customers",
    "Potential Loyalist",
    "New Promising",
    "At Risk",
    "Lost",
    // "Others",
  ];
  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const [summaryRes, segmentRes, walletRes, loyaltyRes] = await Promise.all(
        [
          fetch(`${API_BASE}/summary`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ registrationId }),
          }),
          fetch(`${API_BASE}/segments`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ registrationId }),
          }),

          fetch(`${API_BASE}/wallet-summary`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ registrationId }),
          }),

          fetch(`${API_BASE}/wallet-membership`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ registrationId }),
          }),
        ],
      );

      const summaryData = await summaryRes.json();
      const segmentData = await segmentRes.json();
      const walletData = await walletRes.json();
      const loyaltyData = await loyaltyRes.json();
      setMembershipGaps(loyaltyData.totalMembershipCount);
      setLoyaltyGaps(loyaltyData.totalWalletCount);
      setWalletDetails(walletData);
      setSummary(summaryData);
      setSegments(segmentData.segments || []);
    } catch (error) {
      console.error("Dashboard API error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <p className="text-gray-600">Loading dashboard...</p>
      </div>
    );
  }
  const formatUpdatedDate = (dateValue) => {
    const date = new Date(Number(dateValue));
    const now = new Date();

    const isToday =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    const timePart = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    if (isToday) {
      return `Today, ${timePart}`;
    }

    const datePart = date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return `${datePart}, ${timePart}`;
  };
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="mb-1">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">
          Customer Intelligence
        </h1>

        <div className="flex items-center gap-2 text-xs text-gray-500 mt-0.5 ml-1">
          {/* Updated Time */}
          <span>
            Updated:{" "}
            {summary?.reportDate ? formatUpdatedDate(summary.reportDate) : "—"}
          </span>

          <span>•</span>

          {/* Analysis Window Badge */}
          <span
            className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded border border-gray-200 flex items-center gap-1"
            title="Analysis is capped at 1 year for performance"
          >
            <svg
              className="w-3 h-3 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>

            <span>
              Analyzing:
              <span className="font-bold text-gray-800 ml-1">
                {summary?.analysis_label || "Last 12 Months"}
              </span>
            </span>
          </span>
        </div>
      </div>

      {/* Period Selector & Export */}
      <div className="flex justify-between items-center mb-6">
        {/* <div className="flex gap-2">
          <button className="px-4 py-2 bg-white rounded-lg text-sm font-medium text-gray-900 shadow-sm border border-gray-200">
            30 Days
          </button>
          <button className="px-4 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-white">
            90 Days
          </button>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors">
          <span>↓</span>
          Export Report
        </button> */}
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-5 gap-4 mb-8">
        <SummaryCard
          title="Total Customers"
          value={summary?.totalCustomers}
          //subtitle={10}
          //changeLabel="+35 New"
          theme="primary"

          // badge={{ text: "Database" }}
          //subtitle="+35 vs 30 days ago"
          //status={{ text: "Database", color: "bg-indigo-50 text-indigo-700 border-indigo-200" }}
        />
        <SummaryCard
          title="Champions"
          value={summary?.champions?.customer_count}
          subtitle={summary?.champions?.change_percent}
          changeLabel={summary?.champions.trend_label}
          badge={{
            text: "Elite",
            color: "bg-green-50 text-green-700 border-green-200",
          }}
          totalCustomers={summary?.totalCustomers}
          accentColor="bg-green-500"
        />
        <SummaryCard
          title="Loyal Customers"
          value={summary?.loyalCustomers?.customer_count}
          subtitle={summary?.loyalCustomers?.change_percent}
          changeLabel={summary?.loyalCustomers.trend_label}
          badge={{
            text: "Active",
            color: "bg-blue-100 text-blue-700",
          }}
          totalCustomers={summary?.totalCustomers}
          accentColor="bg-blue-500"
          //status={{ text: "Active", color: "bg-blue-50 text-blue-700 border-blue-200" }}
        />
        <SummaryCard
          title="Potential Loyalist"
          value={summary?.potentialLoyalists?.customer_count}
          subtitle={summary?.potentialLoyalists?.change_percent}
          changeLabel={summary?.potentialLoyalists.trend_label}
          totalCustomers={summary?.totalCustomers}
          accentColor="bg-purple-500"
          // status={{ text: "Inactive", color: "bg-gray-50 text-gray-700 border-gray-200" }}
        />
        <SummaryCard
          title="New Promising"
          value={summary?.newPromising?.customer_count}
          subtitle={summary?.newPromising?.change_percent}
          changeLabel={summary?.newPromising.trend_label}
          totalCustomers={summary?.totalCustomers}
          accentColor="bg-yellow-500"
          // status={{ text: "Inactive", color: "bg-gray-50 text-gray-700 border-gray-200" }}
        />
        <SummaryCard
          title="At Risk"
          value={summary?.atRisk?.customer_count}
          subtitle={summary?.atRisk?.change_percent}
          changeLabel={summary?.atRisk.trend_label}
          badge={{
            text: "Action",
            color: "bg-red-100 text-red-700",
          }}
          borderColor="border-red-200"
          totalCustomers={summary?.totalCustomers}
          accentColor="bg-red-500"
          // status={{ text: "★ Action", color: "bg-red-50 text-red-700 border-red-200" }}
        />

        <SummaryCard
          title="Lost"
          value={summary?.lost?.customer_count}
          changeLabel={summary?.lost.trend_label}
          subtitle={summary?.lost?.change_percent} // status={{ text: "Inactive", color: "bg-gray-50 text-gray-700 border-gray-200" }}
          badge={{
            text: "Inactive",
            color: "bg-gray-50 text-gray-700 border-gray-200",
          }}
          totalCustomers={summary?.totalCustomers}
        />
        {/* <div className="col-span-2"> */}
        <CustomerCaptureCard data={summary?.customer_capture_rate} />
        <WalletLiabilityCard
          total={walletDetails.total_wallet_balance}
          customerCount={walletDetails.customers_with_wallet}
        />

        {/* </div> */}

        {/* <SummaryCard
          title="Others"
          value={summary?.others?.customer_count}
          subtitle={summary?.others?.change_percent}
          // status={{ text: "Inactive", color: "bg-gray-50 text-gray-700 border-gray-200" }}
        /> */}
      </div>
      {/* <div className="grid grid-cols-5 gap-4 mb-8">
  <div className="col-span-2">
    <CustomerCaptureCard data={summary?.customer_capture_rate} />
  </div>
</div> */}
      {/* Segment Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        {/* Table Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-900">
                Segment Performance
              </h2>
              {/*  <p className="text-sm text-gray-500 mt-1">Based on 12-month Rolling Purchase History</p> */}
            </div>
            {/* <div className="flex gap-2">
              <button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                <span>⚙</span>
                Filters
              </button>
              <button className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors">
                Configure Thresholds
              </button>
            </div> */}
          </div>
        </div>

        {/* Table Column Headers */}
        <div className="grid grid-cols-7 gap-6 px-4 py-3 bg-gray-50 border-b border-gray-200">
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Segment Name
          </div>
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Customers
          </div>
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            AVG Spend (AOV)
          </div>
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            BUYING CYCLE
          </div>
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            AVG Recency
          </div>
          <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Insights
          </div>
          {/* <div className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Actions
          </div> */}
        </div>

        {/* Table Rows */}
        <div>
          {segments
            .sort((a, b) => {
              console.log(segmentOrder);
              const indexA = segmentOrder.indexOf(a.segment);
              const indexB = segmentOrder.indexOf(b.segment);

              return indexA - indexB;
            })
            .map((seg) => {
              console.log("first", seg);
              let health = 40;
              if (seg.health == "good") health = 90;
              if (seg.health == "medium") health = 50;
              if (seg.health == "low") health = 10;
              // if (seg.avgRecencyDays < 30) health = 90;
              // else if (seg.avgRecencyDays < 90) health = 60;

              console.log("loyaltyGaps", loyaltyGaps);
              const gap = loyaltyGaps.find((g) => g.segment === seg.segment);

              const loyaltyGap = gap
                ? {
                    count: gap.count,
                    percent: (gap.count / seg.customerCount) * 100,
                  }
                : null;

              const gap2 = membershipGaps.find(
                (g) => g.segment === seg.segment,
              );

              const membershipGap = gap2
                ? {
                    count: gap2.count,
                    percent: (gap2.count / seg.customerCount) * 100,
                  }
                : null;
              console.log("membershipGap", membershipGap);
              return (
                <SegmentRow
                  key={seg.segment}
                  name={seg.segment}
                  avgAOV={seg.avgAOV}
                  //avgFrequency={seg.avgFrequency}
                  avgRecency={seg.avgRecencyDays}
                  // health={health}
                  avgFrequencyRaw={seg.avgFrequencyRaw}
                  frequencyLabel={seg.frequencyLabel}
                  customerCount={seg.customerCount}
                  membershipGap={membershipGap}
                  loyaltyGap={loyaltyGap}
                  onClick={() =>
                    navigate("/crm/customers", {
                      state: { segment: seg.segment },
                    })
                  }
                  onClickLoyalty={() =>
                    navigate("/crm/customers", {
                      state: { segment: seg.segment , wallet: "Empty" },
                    })
                  }
                />
              );
            })}
        </div>

        {/* Table Footer */}
        {/* <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between text-sm text-gray-600"> */}
        {/* /<div>Showing all {segments.length} segments</div> */}
        {/* <div className="flex gap-2">
            <button className="px-3 py-1 text-gray-400 hover:text-gray-700 transition-colors">Previous</button>
            <button className="px-3 py-1 text-gray-700 hover:text-gray-900 transition-colors">Next</button>
          </div> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default CustomersDashboard;